import { z } from "zod"

export const certificateExpiryReminderConfigSchema = z.object({
    enabled: z.boolean(),
    leadDays: z.number().int().positive(),
    notifyPilot: z.boolean(),
    notifyWorkspaceAdmins: z.boolean(),
    customEmails: z.array(z.email()),
})

export const userCertificateRecordSchema = z.object({
    id: z.uuid(),
    org_id: z.uuid(),
    user_id: z.guid(),
    name: z.string().min(1),
    certificate_number: z.string().nullable(),
    issued_at: z.string().nullable(),
    expires_at: z.string().nullable(),
    expiry_config: certificateExpiryReminderConfigSchema.nullable(),
    notes: z.string().nullable(),
    file_name: z.string().nullable(),
    file_size_bytes: z.coerce.number().int().nullish(),
    created_at: z.string(),
    updated_at: z.string().nullable(),
})

export const userCertificateSchema = userCertificateRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    userId: r.user_id,
    name: r.name,
    certificateNumber: r.certificate_number,
    issuedAt: r.issued_at,
    expiresAt: r.expires_at,
    expiryConfig: r.expiry_config,
    notes: r.notes,
    fileName: r.file_name,
    fileSizeBytes: r.file_size_bytes,
    createdAt: r.created_at,
    updatedAt: r.updated_at,
}))

export const creatableUserCertificateSchema = userCertificateRecordSchema.omit({
    id: true,
    created_at: true,
    updated_at: true,
    org_id: true,
})

export const updatableUserCertificateSchema = userCertificateRecordSchema.pick({
    name: true,
    certificate_number: true,
    issued_at: true,
    expires_at: true,
    expiry_config: true,
    notes: true,
    file_name: true,
    file_size_bytes: true,
})

export const certificateNotificationRecordSchema = z.object({
    certificate_id: z.uuid(),
    kind: z.string(),
    anchor_date: z.string(),
})

export type CertificateNotificationRecord = z.infer<typeof certificateNotificationRecordSchema>
export type CertificateExpiryReminderConfig = z.infer<typeof certificateExpiryReminderConfigSchema>
export type UserCertificateRecord = z.infer<typeof userCertificateRecordSchema>
export type UserCertificate = z.infer<typeof userCertificateSchema>
export type CreatableUserCertificate = z.infer<typeof creatableUserCertificateSchema>
export type UpdatableUserCertificate = z.infer<typeof updatableUserCertificateSchema>
